import FaiBox from "MuiComponents/FaiBox";
import FaiTypography from "MuiComponents/FaiTypography";

export default function PageHeader({ title = "", content = "" }) {
	return (
		<FaiBox className="mb-2">
			<FaiTypography variant="h4" className="!text-xl !font-semibold !mb-2">
				{title}
			</FaiTypography>
			<FaiTypography variant="h6" className="!text-base !font-normal">
				{content}
			</FaiTypography>
		</FaiBox>
	);
}
